"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("./client");
class WindowClient extends client_1.RoamClient {
    constructor() {
        super();
        if (!window) {
            throw new Error("Client could only be used in a Window");
        }
    }
    post(body) {
        if (!window.roamDatomicAlphaAPI) {
            throw new Error("Client could only be used with new Roam backend");
        }
        return window
            .roamDatomicAlphaAPI(body)
            .then((r) => (typeof r.success !== "undefined" ? r.success : r));
    }
}
exports.default = WindowClient;
